// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e6f15be5","239":"c2ee4aa6","455":"511d0166","488":"4da35ac7"}[chunkId] + ".chunk.js";
};